var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loggedIn
    ? _c(
        "div",
        { staticClass: "gift-choice-page", attrs: { id: "canvas" } },
        [
          !_vm.isCustomHeader || !_vm.collectionImage
            ? _c("div", { staticClass: "header" }, [
                _c("img", {
                  attrs: {
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/header_0c9e2d5f-1450-455e-b987-c0b865bcf0f9.svg?v=1683210161"
                  }
                })
              ])
            : _c("div", { staticClass: "header custom" }, [
                _vm.collectionImage
                  ? _c("img", {
                      staticClass: "desktop",
                      attrs: { src: _vm.collectionImage.src }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.collectionImage
                  ? _c("img", {
                      staticClass: "mobile",
                      attrs: { src: _vm.collectionImage.alt }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.collectionImage
                  ? _c("p", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.collectionTitle))
                    ])
                  : _vm._e()
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "main-container" }, [
            !_vm.isCustomHeader
              ? _c("p", { staticClass: "main-title" }, [
                  _vm._v("We've got some great gifts for you to choose from ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "gifting-header" },
              [
                _c("div", {
                  staticStyle: {
                    width: "33.3%",
                    "flex-grow": "0",
                    "flex-shrink": "0"
                  }
                }),
                _vm._v(" "),
                _vm._l(_vm.steps, function(step, i) {
                  return _c(
                    "div",
                    {
                      key: step,
                      staticClass: "header-step",
                      class: _vm.currentStep == i ? "current" : ""
                    },
                    [
                      _c("p", { staticClass: "title" }, [_vm._v(_vm._s(step))]),
                      _vm._v(" "),
                      _c("p", { staticClass: "circle" })
                    ]
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "header-line" })
              ],
              2
            ),
            _vm._v(" "),
            _vm.products.length > 0
              ? _c(
                  "div",
                  { staticClass: "products-container" },
                  _vm._l(_vm.products, function(product) {
                    return _c(
                      "div",
                      { key: product.id, staticClass: "product-container" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "product-image-container",
                            class:
                              product == _vm.selectedProduct ? "selected" : "",
                            on: {
                              click: function($event) {
                                return _vm.selectDescProduct(product)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "info mobile",
                              attrs: {
                                src:
                                  "https://cdn.shopify.com/s/files/1/1363/8433/files/info_icon_9b78e5b1-b9be-49ca-826c-b3734c2991c5.svg?v=1683232689"
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "main-image",
                              attrs: { src: _vm._f("getProductImage")(product) }
                            }),
                            _vm._v(" "),
                            product.images.length > 1
                              ? _c("img", {
                                  staticClass: "hover-image",
                                  attrs: { src: product.images[1].src }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._m(0, true)
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "product-title" }, [
                          _vm._v(_vm._s(product.title))
                        ]),
                        _vm._v(" "),
                        _vm.selectedProduct &&
                        product.id == _vm.selectedProduct.id
                          ? _c(
                              "button",
                              {
                                staticClass: "happybox-button yellow",
                                on: { click: _vm.goCheckout }
                              },
                              [_vm._v("Next >")]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "happybox-button white",
                                on: {
                                  click: function($event) {
                                    return _vm.selectProduct(product)
                                  }
                                }
                              },
                              [_vm._v("Select")]
                            )
                      ]
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "spinner-container" }, [
                  _c("div", { staticClass: "spinner" })
                ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "continue-container",
                class: _vm.selectedProduct ? "sticky" : ""
              },
              [
                !_vm.selectedProduct
                  ? _c("button", { staticClass: "happybox-button gray" }, [
                      _vm._v("Select Your Gift")
                    ])
                  : _c(
                      "button",
                      {
                        staticClass: "happybox-button yellow",
                        class: _vm.isLoading ? "isLoading" : "",
                        attrs: { disabled: !_vm.selectedProduct },
                        on: { click: _vm.goCheckout }
                      },
                      [_vm._v(_vm._s(_vm.buttonText))]
                    )
              ]
            )
          ]),
          _vm._v(" "),
          _vm.descProduct
            ? _c("ProductModal", {
                attrs: {
                  isLoading: _vm.isLoading,
                  product: _vm.descProduct,
                  selectedProduct: _vm.selectedProduct,
                  isCustomHeader: _vm.isCustomHeader
                },
                on: {
                  changevariant: _vm.changeVariant,
                  checkout: _vm.goCheckout,
                  closemodal: _vm.closeModal,
                  selectproduct: function($event) {
                    return _vm.selectProduct($event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "spinner-container", class: _vm.reclaimed ? "top" : "" },
        [
          _vm.invalidToken
            ? _c("p", [_vm._v("Invalid Access")])
            : _vm.reclaimed
            ? _c("div", { staticClass: "reclaimed-container" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("p", { staticClass: "subtitle" }, [
                  _vm._v("You'll receive updates and tracking info via email!")
                ])
              ])
            : _c("div", { staticClass: "loading-container" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "spinner" })
              ])
        ]
      )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hover-container" }, [
      _c("p", [_vm._v("TAKE A PEEK")]),
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/eyes.svg?v=1683212003"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"
        }
      }),
      _vm._v(" "),
      _c("span", [_vm._v("Great Choice")]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n      If you are having trouble loading this page, please turn off your VPN or company wifi. "
      ),
      _c("br", { staticClass: "desktop" }),
      _vm._v(
        " Due to IT security restrictions, you may need to open the link on a personal device or forward the email to a personal email address to redeem your gift."
      ),
      _c("br", { staticClass: "desktop" }),
      _vm._v("\n      If you are still having issues, please reach out to "),
      _c("a", { attrs: { href: "mailto:orders@happyboxstore.com" } }, [
        _vm._v("orders@happyboxstore.com")
      ]),
      _vm._v(" for immediate assistance.\n    ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }